export default {
    "logout": "api/logout",
    "password.email": "api/forgot-password",
    "password.update": "api/reset-password",
    "user.register": "api/register",
    "verification.verify": "api/email/verify/{id}/{hash}",
    "verification.send": "api/email/verification-notification",
    "user-profile-information.update": "api/user/profile-information",
    "user-password.update": "api/user/password",
    "password.confirmation": "api/user/confirmed-password-status",
    "password.confirm": "api/user/confirm-password",
    "stancl.tenancy.asset": "tenancy/assets/{path?}",
    "telescope": "telescope/{view?}",
    "api.interactions.store": "api/v1/interactions",
    "api.interactions.update": "api/v1/interactions/{interaction}",
    "api.interactions.index": "api/v1/interactions",
    "api.interactions.options": "api/v1/interactions/options",
    "api.interactions.status.update": "api/v1/interactions/{interaction}/status",
    "api.shadow-talents.index": "api/v1/shadow-talents",
    "api.shadow-talents.store": "api/v1/shadow-talents",
    "api.shadow-talents.show": "api/v1/shadow-talents/{shadowTalent}",
    "api.shadow-talents.update": "api/v1/shadow-talents/{shadowTalent}",
    "api.shadow-talents.destroy": "api/v1/shadow-talents/{shadowTalent}",
    "hirewise.talent.report.callback": "api/hirewise-talent-report-callback",
    "hirewise.evaluation.completion.callback": "api/hirewise-evaluation-completion-callback",
    "tenant-user.workspaces": "api/tenant-user/workspaces",
    "tenant-user.login": "api/tenant-user/attempt",
    "home": "{url}",
    "login": "admin-login",
    "tenants": "tenants",
    "tenants.update": "tenants/{tenant}",
    "tenants.settings": "tenants/{tenant}/settings",
    "tenants.show": "tenants/{tenant}",
    "tenants.view": "tenants/{tenant}/user/{user}",
    "admin.logout": "logout",
    "tenants.activities": "tenants/{tenant}/activities",
    "tenants.activities.download": "tenants/{tenant}/activities/download",
    "admin.password.reset.form": "admin/password/reset",
    "admin.password.reset": "admin/password/reset",
    "tenant-api.short-link.redirect": "api/v1/s/{code}",
    "tenant-api.workmap-templates.index": "api/v1/workmap-templates",
    "tenant-api.users.index": "api/v1/users",
    "tenant-api.users.store": "api/v1/users",
    "tenant-api.users.show": "api/v1/users/profile",
    "tenant-api.users.destroy": "api/v1/users/{user}",
    "tenant-api.users.restoreusers.restore": "api/v1/users/{user}/restore",
    "tenant-api.users.send-invitation": "api/v1/users/send-invitation/{user}",
    "tenant-api.users.roles.index": "api/v1/users/roles",
    "tenant-api.users.roles.update": "api/v1/users/roles",
    "tenant-api.skills.index": "api/v1/skills",
    "tenant-api.skills.store": "api/v1/skills",
    "tenant-api.media.store": "api/v1/media",
    "tenant-api.work-requests.engagement": "api/v1/work-requests/engagement/{workRequest}",
    "tenant-api.work-requests.talents.index": "api/v1/work-requests/talents",
    "tenant-api.work-requests.talents.store": "api/v1/work-requests/talents",
    "tenant-api.work-requests.talents.destroy": "api/v1/work-requests/talents/{talent}",
    "tenant-api.work-requests.talents.update-status": "api/v1/work-requests/{workRequest}/talents/{talent}/status",
    "tenant-api.talents.commitments": "api/v1/talents/{talent}/commitments",
    "tenant-api.workRequest.download": "api/v1/work-requests/{workRequest}/download",
    "tenant-api.work-requests.index": "api/v1/work-requests",
    "tenant-api.work-requests.store": "api/v1/work-requests",
    "tenant-api.work-requests.show": "api/v1/work-requests/{work_request}",
    "tenant-api.work-requests.update": "api/v1/work-requests/{work_request}",
    "tenant-api.archetypes.duplicate": "api/v1/archetypes/{archetype}/duplicate",
    "tenant-api.archetypes.index": "api/v1/archetypes",
    "tenant-api.archetypes.store": "api/v1/archetypes",
    "tenant-api.archetypes.show": "api/v1/archetypes/{archetype}",
    "tenant-api.archetypes.update": "api/v1/archetypes/{archetype}",
    "tenant-api.archetypes.destroy": "api/v1/archetypes/{archetype}",
    "tenant-api.frameworks.index": "api/v1/workmaps/frameworks",
    "tenant-api.workmaps.workmapCard.restore": "api/v1/workmaps/{workmap}/workmap-card/{workmapCard}/restore",
    "tenant-api.workmaps.workmapCard.updateParents": "api/v1/workmaps/{workmap}/workmap-card/update-parents",
    "tenant-api.workmaps.workmapCard.updateCollapseState": "api/v1/workmaps/{workmap}/workmap-card/{workmapCard}/update-collapse-state",
    "tenant-api.workmaps.workmapCard.updateAssignee": "api/v1/workmaps/{workmap}/workmap-card/{workmapCard}/update-assignee",
    "tenant-api.workmaps.index": "api/v1/workmaps",
    "tenant-api.workmaps.store": "api/v1/workmaps",
    "tenant-api.workmaps.show": "api/v1/workmaps/{workmap}",
    "tenant-api.workmaps.update": "api/v1/workmaps/{workmap}",
    "tenant-api.workmaps.workmap-card.index": "api/v1/workmaps/{workmap}/workmap-card",
    "tenant-api.workmaps.workmap-card.store": "api/v1/workmaps/{workmap}/workmap-card",
    "tenant-api.workmaps.workmap-card.update": "api/v1/workmaps/{workmap}/workmap-card/{workmap_card}",
    "tenant-api.workmaps.workmap-card.destroy": "api/v1/workmaps/{workmap}/workmap-card/{workmap_card}",
    "tenant-api.prompts.index": "api/v1/prompts",
    "tenant-api.prompts.store": "api/v1/prompts",
    "tenant-api.workmaps.users.index": "api/v1/workmaps/{workmap}/users",
    "tenant-api.workmaps.users.store": "api/v1/workmaps/{workmap}/users",
    "tenant-api.workmaps.users.update": "api/v1/workmaps/{workmap}/users/{user}",
    "tenant-api.workmaps.users.destroy": "api/v1/workmaps/{workmap}/users/{user}",
    "tenant-api.workmaps.newUsers.index": "api/v1/workmaps/{workmap}/new-users",
    "tenant-api.talents.endorsables-verifiables.history": "api/v1/talents/{talent}/{type}/{typeId}/history",
    "tenant-api.talents.cv-upload": "api/v1/talents/cv-upload",
    "tenant-api.talents.cv-update": "api/v1/talents/{talent}/cv-update",
    "tenant-api.talents.toggle-skill-verification": "api/v1/talents/{talent}/toggle-skill-verification",
    "tenant-api.talents.toggle-archetype-verification": "api/v1/talents/{talent}/toggle-archetype-verification",
    "tenant-api.talents.toggle-skill-endorsement": "api/v1/talents/{talent}/toggle-skill-endorsement",
    "tenant-api.talents.toggle-archetype-endorsement": "api/v1/talents/{talent}/toggle-archetype-endorsement",
    "tenant-api.talents.skills.update": "api/v1/talents/{talent}/skills",
    "tenant-api.talents.talent-clouds.update": "api/v1/talents/{talent}/clouds",
    "tenant-api.talents.archetypes.update": "api/v1/talents/{talent}/archetypes",
    "tenant-api.talents.hirewise-talent-report": "api/v1/talents/{talentId}/hirewise-talent-report",
    "tenant-api.talents.skills.index": "api/v1/talents/{talentId}/skills",
    "tenant-api.talents.archetypes.index": "api/v1/talents/{talentId}/archetypes",
    "tenant-api.talents.cancel-objectives": "api/v1/talents/{talent}/cancel-objectives",
    "tenant-api.talents.index": "api/v1/talents",
    "tenant-api.talents.store": "api/v1/talents",
    "tenant-api.talents.show": "api/v1/talents/{talent}",
    "tenant-api.talents.update": "api/v1/talents/{talent}",
    "tenant-api.talents.destroy": "api/v1/talents/{talent}",
    "tenant-api.talent-compliance-types.index": "api/v1/talent-compliance-types",
    "tenant-api.talent-compliance-types.store": "api/v1/talent-compliance-types",
    "tenant-api.talent-compliance-types.update": "api/v1/talent-compliance-types/{talent_compliance_type}",
    "tenant-api.talent-compliance-types.destroy": "api/v1/talent-compliance-types/{talent_compliance_type}",
    "tenant-api.talent-compliance-types.metadata-fields.index": "api/v1/talent-compliance-types/{talent_compliance_type}/metadata-fields",
    "tenant-api.talent-compliance-types.metadata-fields.store": "api/v1/talent-compliance-types/{talent_compliance_type}/metadata-fields",
    "tenant-api.talent-compliance-types.metadata-fields.destroy": "api/v1/talent-compliance-types/{talent_compliance_type}/metadata-fields/{metadata_field}",
    "tenant-api.talents.compliances.index": "api/v1/talents/{talent}/compliances",
    "tenant-api.talents.compliances.store": "api/v1/talents/{talent}/compliances",
    "tenant-api.talents.compliances.show": "api/v1/talents/{talent}/compliances/{compliance}",
    "tenant-api.talents.compliances.update": "api/v1/talents/{talent}/compliances/{compliance}",
    "tenant-api.talents.compliances.destroy": "api/v1/talents/{talent}/compliances/{compliance}",
    "tenant-api.talent-compliance-options": "api/v1/talent-compliance-options",
    "tenant-api.talent-channels.index": "api/v1/talent-channels",
    "tenant-api.talent-channels.store": "api/v1/talent-channels",
    "tenant-api.talent-channels.show": "api/v1/talent-channels/{talent_channel}",
    "tenant-api.talent-channels.update": "api/v1/talent-channels/{talent_channel}",
    "tenant-api.talent-channels.destroy": "api/v1/talent-channels/{talent_channel}",
    "tenant-api.talent-channels.restore": "api/v1/talent-channels/{id}/restore",
    "tenant-api.job-categories-list": "api/v1/job-categories",
    "tenant-api.talent-cloud-options": "api/v1/talent-cloud-options",
    "tenant-api.talent-clouds.index": "api/v1/talent-clouds",
    "tenant-api.talent-clouds.store": "api/v1/talent-clouds",
    "tenant-api.talent-clouds.show": "api/v1/talent-clouds/{talent_cloud}",
    "tenant-api.talent-clouds.update": "api/v1/talent-clouds/{talent_cloud}",
    "tenant-api.talent-clouds.destroy": "api/v1/talent-clouds/{talent_cloud}",
    "tenant-api.talent-clouds.restore": "api/v1/talent-clouds/{id}/restore",
    "tenant-api.talent-cloud-roles.store": "api/v1/talent-cloud-roles",
    "tenant-api.talent-cloud-roles.update": "api/v1/talent-cloud-roles/{talentCloud}",
    "tenant-api.talent-cloud-roles.destroy": "api/v1/talent-cloud-roles/{talentCloud}",
    "tenant-api.talent-statuses-list": "api/v1/talent-statuses",
    "tenant-api.talent-options": "api/v1/talent-options",
    "tenant-api.states.index": "api/v1/states",
    "tenant-api.cities.index": "api/v1/cities",
    "tenant-api.timezones.index": "api/v1/timezones",
    "tenant-api.notify-talent-contact-accessed": "api/v1/notify-talent-contact-accessed/{talentId}",
    "tenant-api.interactions.retry-ai-request": "api/v1/interactions/retry-ai-request",
    "tenant-api.interactions.update": "api/v1/interactions/{interaction}",
    "tenant-api.interactions.index": "api/v1/interactions",
    "tenant-api.interactions.options": "api/v1/interactions/options",
    "tenant-api.interactions.status.update": "api/v1/interactions/{interaction}/status",
    "tenant-api.shadow-talents.index": "api/v1/shadow-talents",
    "tenant-api.shadow-talents.store": "api/v1/shadow-talents",
    "tenant-api.shadow-talents.show": "api/v1/shadow-talents/{shadowTalent}",
    "tenant-api.shadow-talents.update": "api/v1/shadow-talents/{shadowTalent}",
    "tenant-api.shadow-talents.destroy": "api/v1/shadow-talents/{shadowTalent}",
    "tenant-api.talents.notes.search-suggestions": "api/v1/talents/{talent}/notes/search-suggestions",
    "tenant-api.talents.notes.index": "api/v1/talents/{talent}/notes",
    "tenant-api.talents.notes.store": "api/v1/talents/{talent}/notes",
    "tenant-api.talents.notes.show": "api/v1/talents/{talent}/notes/{note}",
    "tenant-api.talents.notes.update": "api/v1/talents/{talent}/notes/{note}",
    "tenant-api.talents.notes.destroy": "api/v1/talents/{talent}/notes/{note}",
    "tenant-api.talent.notes.options": "api/v1/talent-note-options",
    "tenant-api.talents.availabilities.check-conflicts": "api/v1/talents/{talentId}/availabilities/check-conflicts/{availabilityId?}",
    "tenant-api.talents.availabilities.options": "api/v1/talents/availabilities/options",
    "tenant-api.talents.availabilities.index": "api/v1/talents/{talent}/availabilities",
    "tenant-api.talents.availabilities.store": "api/v1/talents/{talent}/availabilities",
    "tenant-api.talents.availabilities.show": "api/v1/talents/{talent}/availabilities/{availability}",
    "tenant-api.talents.availabilities.update": "api/v1/talents/{talent}/availabilities/{availability}",
    "tenant-api.talents.availabilities.destroy": "api/v1/talents/{talent}/availabilities/{availability}",
    "tenant-api.settings.store": "api/v1/settings",
    "tenant-api.settings.show": "api/v1/settings",
    "tenant-api.short-link.store": "api/v1/s",
    "tenant-api.tags.index": "api/v1/tags",
    "tenant-api.tags.store": "api/v1/tags",
    "impersonate": "impersonate/{token}",
    "short-link.redirect": "s/{code}",
    "short-link.unlock": "s/{code}/unlock",
    "verification.confirm": "api/email/confirm",
    "auto-login": "api/auto-login",
    "short-link.store": "api/s",
    "workmap-templates.index": "api/workmap-templates",
    "users.index": "api/users",
    "users.store": "api/users",
    "users.show": "api/users/profile",
    "users.cancel-invitation": "api/users/cancel-invitation/{user}",
    "users.destroy": "api/users/{user}",
    "users.restoreusers.restore": "api/users/{user}/restore",
    "users.send-invitation": "api/users/send-invitation/{user}",
    "users.roles.index": "api/users/roles",
    "users.roles.update": "api/users/roles",
    "skills.index": "api/skills",
    "skills.store": "api/skills",
    "media.store": "api/media",
    "work-requests.engagement": "api/work-requests/engagement/{workRequest}",
    "work-requests.talents.index": "api/work-requests/talents",
    "work-requests.talents.store": "api/work-requests/talents",
    "work-requests.talents.destroy": "api/work-requests/talents/{workRequest}",
    "work-requests.talents.update-status": "api/work-requests/{workRequest}/talents/{talent}/status",
    "talents.commitments": "api/talents/{talent}/commitments",
    "workRequest.download": "api/work-requests/{workRequest}/download",
    "work-requests.index": "api/work-requests",
    "work-requests.store": "api/work-requests",
    "work-requests.show": "api/work-requests/{work_request}",
    "work-requests.update": "api/work-requests/{work_request}",
    "talents.trigger-ai": "api/talents/{talent}/trigger-ai",
    "talents.cancel-objectives": "api/talents/{talent}/cancel-objectives",
    "talents.endorsables-verifiables.history": "api/talents/{talent}/{type}/{typeId}/history",
    "talents.cv-upload": "api/talents/cv-upload",
    "talents.cv-update": "api/talents/{talent}/cv-update",
    "talents.toggle-skill-verification": "api/talents/{talent}/toggle-skill-verification",
    "talents.toggle-archetype-verification": "api/talents/{talent}/toggle-archetype-verification",
    "talents.toggle-skill-endorsement": "api/talents/{talent}/toggle-skill-endorsement",
    "talents.toggle-archetype-endorsement": "api/talents/{talent}/toggle-archetype-endorsement",
    "talent-sources.index": "api/talent-sources",
    "talent-sources.create": "api/talent-sources/create",
    "talent-sources.store": "api/talent-sources",
    "talent-sources.show": "api/talent-sources/{talent_source}",
    "talent-sources.edit": "api/talent-sources/{talent_source}/edit",
    "talent-sources.update": "api/talent-sources/{talent_source}",
    "talent-sources.destroy": "api/talent-sources/{talent_source}",
    "talents.skills.update": "api/talents/{talent}/skills",
    "talents.talent-clouds.update": "api/talents/{talent}/clouds",
    "talents.archetypes.update": "api/talents/{talent}/archetypes",
    "talents.hirewise-talent-report": "api/talents/{talentId}/hirewise-talent-report",
    "talents.skills.index": "api/talents/{talentId}/skills",
    "talents.archetypes.index": "api/talents/{talentId}/archetypes",
    "talents.index": "api/talents",
    "talents.store": "api/talents",
    "talents.show": "api/talents/{talent}",
    "talents.update": "api/talents/{talent}",
    "talents.destroy": "api/talents/{talent}",
    "talent-channels.index": "api/talent-channels",
    "talent-channels.store": "api/talent-channels",
    "talent-channels.show": "api/talent-channels/{talent_channel}",
    "talent-channels.update": "api/talent-channels/{talent_channel}",
    "talent-channels.destroy": "api/talent-channels/{talent_channel}",
    "talent-channels.restore": "api/talent-channels/{id}/restore",
    "talent-statuses-list": "api/talent-statuses",
    "talent-options": "api/talent-options",
    "talent-compliance-types.index": "api/talent-compliance-types",
    "talent-compliance-types.store": "api/talent-compliance-types",
    "talent-compliance-types.update": "api/talent-compliance-types/{talent_compliance_type}",
    "talent-compliance-types.destroy": "api/talent-compliance-types/{talent_compliance_type}",
    "talent-compliance-types.metadata-fields.index": "api/talent-compliance-types/{talent_compliance_type}/metadata-fields",
    "talent-compliance-types.metadata-fields.store": "api/talent-compliance-types/{talent_compliance_type}/metadata-fields",
    "talent-compliance-types.metadata-fields.destroy": "api/talent-compliance-types/{talent_compliance_type}/metadata-fields/{metadata_field}",
    "talent-compliance-types.settings-fields": "api/talent-compliance-types/{talentComplianceType}/settings-fields",
    "talents.compliances.index": "api/talents/{talent}/compliances",
    "talents.compliances.store": "api/talents/{talent}/compliances",
    "talents.compliances.show": "api/talents/{talent}/compliances/{compliance}",
    "talents.compliances.update": "api/talents/{talent}/compliances/{compliance}",
    "talents.compliances.destroy": "api/talents/{talent}/compliances/{compliance}",
    "talent-compliance-options": "api/talent-compliance-options",
    "talent-clouds.duplicate": "api/talent-clouds/{talentCloud}/duplicate",
    "talent-cloud-options": "api/talent-cloud-options",
    "talent-clouds.index": "api/talent-clouds",
    "talent-clouds.store": "api/talent-clouds",
    "talent-clouds.show": "api/talent-clouds/{talent_cloud}",
    "talent-clouds.update": "api/talent-clouds/{talent_cloud}",
    "talent-clouds.destroy": "api/talent-clouds/{talent_cloud}",
    "talent-clouds.restore": "api/talent-clouds/{id}/restore",
    "talent-cloud-roles.index": "api/talent-cloud-roles/{talentCloud}",
    "talent-cloud-roles.store": "api/talent-cloud-roles",
    "talent-cloud-roles.update": "api/talent-cloud-roles/{talentCloud}",
    "talent-cloud-roles.destroy": "api/talent-cloud-roles/{talentCloud}",
    "archetypes.duplicate": "api/archetypes/{archetype}/duplicate",
    "archetypes.index": "api/archetypes",
    "archetypes.store": "api/archetypes",
    "archetypes.show": "api/archetypes/{archetype}",
    "archetypes.update": "api/archetypes/{archetype}",
    "archetypes.destroy": "api/archetypes/{archetype}",
    "interactions.retry-ai-request": "api/interactions/retry-ai-request",
    "interactions.store": "api/interactions",
    "interactions.update": "api/interactions/{interaction}",
    "interactions.index": "api/interactions",
    "interactions.options": "api/interactions/options",
    "interactions.status.update": "api/interactions/{interaction}/status",
    "shadow-talents.index": "api/shadow-talents",
    "shadow-talents.store": "api/shadow-talents",
    "shadow-talents.show": "api/shadow-talents/{shadowTalent}",
    "shadow-talents.update": "api/shadow-talents/{shadowTalent}",
    "shadow-talents.destroy": "api/shadow-talents/{shadowTalent}",
    "talents.notes.search-suggestions": "api/talents/{talent}/notes/search-suggestions",
    "talents.notes.index": "api/talents/{talent}/notes",
    "talents.notes.store": "api/talents/{talent}/notes",
    "talents.notes.show": "api/talents/{talent}/notes/{note}",
    "talents.notes.update": "api/talents/{talent}/notes/{note}",
    "talents.notes.destroy": "api/talents/{talent}/notes/{note}",
    "talent.notes.options": "api/talent-note-options",
    "talents.availabilities.check-conflicts": "api/talents/{talentId}/availabilities/check-conflicts/{availabilityId?}",
    "talents.availabilities.options": "api/talents/availabilities/options",
    "talents.availabilities.index": "api/talents/{talent}/availabilities",
    "talents.availabilities.store": "api/talents/{talent}/availabilities",
    "talents.availabilities.show": "api/talents/{talent}/availabilities/{availability}",
    "talents.availabilities.update": "api/talents/{talent}/availabilities/{availability}",
    "talents.availabilities.destroy": "api/talents/{talent}/availabilities/{availability}",
    "frameworks.index": "api/workmaps/frameworks",
    "workmaps.index": "api/workmaps",
    "workmaps.store": "api/workmaps",
    "workmaps.show": "api/workmaps/{workmap}",
    "workmaps.update": "api/workmaps/{workmap}",
    "prompts.index": "api/prompts",
    "prompts.store": "api/prompts",
    "workmaps.workmapCard.index": "api/workmaps/{workmap}/workmapCard",
    "workmaps.workmapCard.store": "api/workmaps/{workmap}/workmapCard",
    "workmaps.workmapCard.update": "api/workmaps/{workmap}/workmapCard/{workmapCard}",
    "workmaps.workmapCard.destroy": "api/workmaps/{workmap}/workmapCard/{workmapCard}",
    "workmaps.workmapCard.restore": "api/workmaps/{workmap}/workmapCard/{workmapCard}/restore",
    "workmaps.workmapCard.updateParents": "api/workmaps/{workmap}/workmapCard/update-parents",
    "workmaps.workmapCard.updateCollapseState": "api/workmaps/{workmap}/workmapCard/{workmapCard}/update-collapse-state",
    "workmaps.workmapCard.updateAssignee": "api/workmaps/{workmap}/workmapCard/{workmapCard}/update-assignee",
    "workmaps.users.index": "api/workmaps/{workmap}/users",
    "workmaps.users.store": "api/workmaps/{workmap}/users",
    "workmaps.users.update": "api/workmaps/{workmap}/users/{user}",
    "workmaps.users.destroy": "api/workmaps/{workmap}/users/{user}",
    "workmaps.newUsers.index": "api/workmaps/{workmap}/new-users",
    "workmaps.workmapSlides.index": "api/workmaps/{workmap}/workmapSlides",
    "workmaps.workmapSlides.store": "api/workmaps/{workmap}/workmapSlides",
    "workmaps.workmapSlides.show": "api/workmaps/{workmap}/workmapSlides/{workmapSlide}",
    "workmaps.workmapSlides.update": "api/workmaps/{workmap}/workmapSlides/{workmapSlide}",
    "workmaps.workmapSlides.destroy": "api/workmaps/{workmap}/workmapSlides/{workmapSlide}",
    "notify-talent-contact-accessed": "api/notify-talent-contact-accessed/{talentId}",
    "cities.index": "api/cities",
    "timezones.index": "api/timezones",
    "states.index": "api/states",
    "job-categories-list": "api/job-categories",
    "eve-objectives.index": "api/eve-objectives",
    "settings.store": "api/settings",
    "settings.show": "api/settings",
    "tags.index": "api/tags",
    "tags.store": "api/tags",
    "interactions.index.email": "interactions",
    "talent-clouds.show.email": "talent-clouds/{talent_cloud}",
    "talent-clouds.index.email": "talent-clouds",
    "workmap.edit": "workmaps/{id}/edit",
    "workmap.create": "workmaps/create",
    "talents.show.email": "talents/{talent}",
    "talents.edit.email": "talents/{talent}/edit",
    "two-factor-confirm": "two-factor-confirm",
    "verification.notice": "email/verify",
    "password.reset": "reset-password/{token}",
    "/": "/",
    "dashboard": "dashboard"
};